import React, { useContext } from 'react';
import Styles from './ClubRegistrationDashboardRedirect.module.scss';
import arrowLeft from '../../assets/images/icons/arrow-left.svg';
import { LocalizationContext } from '../../context/localizationContext';
import { clubsContext } from '../../context/clubsContext';

const DashboardRedirect = (props) => {
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const clubContext = useContext(clubsContext);
  const { state, dispatch } = clubContext;
  const { button, notification } = localizationState.localization;
  const { onClick } = props;

  const handleOnClick = () => {
    if (state.selectedClubs.length) {
      if (window.confirm(notification.clubsNotRegisteredAlert)) {
        dispatch({
          type: 'SET_SEARCHED_AND_SELECTED_CLUBS',
          searchedClubs: null,
          selectedClubs: [],
        });
        onClick();
      }
    } else {
      onClick();
    }
  };

  return (
    <div className={Styles.btnContainer}>
      <button
        type="button"
        className={Styles.redirectButton}
        onClick={handleOnClick}
      >
        <img src={arrowLeft} /> {button.backToDashboard}
      </button>
    </div>
  );
};

export default DashboardRedirect;
